var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgW(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 57.126 57.126",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cy: 28.563,
    cx: 28.563,
    r: 28.563,
    style: {
      fill: "#fccc0a"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.231 14.605h6.4c3.68 15.72 4.04 17.72 4.56 21h.08c.52-3 .96-5.92 4-21h6.359c3.36 15.76 3.641 17.28 4.28 21h.08c.48-2.721.96-5.2 4.68-21h6.08l-8.08 28.72h-5.76c-2.96-14.08-3.479-16.88-4.44-22.4h-.079c-.88 5.52-1.36 7.6-4.44 22.4h-5.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgW);
export default __webpack_public_path__ + "static/media/w.bebd8c5499060156fdc43c26128f131d.svg";
export { ForwardRef as ReactComponent };